import { schema } from 'normalizr';
import { Institution } from 'redux/schemas/models/institution';

// eslint-disable-next-line import/prefer-default-export
export const institutionSchema = new schema.Entity<Institution>('institutions');
